import { render, staticRenderFns } from "./ListTipoVeiculoView.vue?vue&type=template&id=4b719441&"
import script from "./ListTipoVeiculoView.vue?vue&type=script&lang=ts&"
export * from "./ListTipoVeiculoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports